import StackInfoTable from "./components/StackInfoTable";

const SetupStackInfo = () => {
  return <StackInfoTable />;
};

export default SetupStackInfo;
